enum RAQIV2ReservedDimensionValues {
  Unknown = 'RAQI_RESERVED_DIMENSION_VALUES_UNKNOWN',
  NoValue = 'RAQI_RESERVED_DIMENSION_VALUES_NO_VALUE',
}

export default RAQIV2ReservedDimensionValues;
